export enum EventParticipateErrorCodes {
  Unknown = 'Unknown',
  ExpiredParticipateDate = 'ExpiredParticipateDate',
  AlreadyParticipateEvent = 'AlreadyParticipateEvent',
}
